<div [ngClass]="{ 'linq-file-upload-target-wrapper': true, 'linq-file-upload-target-wrapper--error': error }">
	<span *ngIf="label" class="linq-file-upload-label">{{ label }}</span>
	<div [ngClass]="{ 'linq-file-upload-target': true, 'linq-file-upload-target--error': error }" fileUploadDragAndDrop
		(fileDropped)="onFileDropped($event)" tabindex="0">
		<div class="linq-file-upload-target__content">
			<mat-icon class="linq-file-upload-target__icon">cloud_upload</mat-icon>
			<span>
				Drag and drop here<br />
				or<br />
				<label [for]="uniqueId">browse</label>
			</span>
			<input [id]="uniqueId" type="file" [multiple]="multiple" [accept]="allowedExtensions.join(',')"
				(change)="fileBrowseHandler($event.target.files)" />
			<span>{{ helpText }}</span>
		</div>
	</div>
	<span *ngIf="error" class="linq-file-upload-file-error">{{ error }}</span>
</div>
